import React from 'react';

export const AppBuilderIntegrationSlots = () => {
  return (
    <>
      <slot name="appBuilderLabs" />
    </>
  );
};
